export interface DynamicConfig {
  //powerBiApiUrl: string;
  instrumentationKey: string;
  directApiUrl: string;
  apiUrl: string;
  envName: "DEV" | "TST" | "AKC" | "PROD";
  enableFormsAuth: string;
  defaultSiteId: string;
  agGridLicense: string;
  trackException: boolean;
  trackRequest: boolean;
  trackResponse: boolean;
}

export const defaultConfig: DynamicConfig = {
  // powerBiApiUrl: "https://localhost:7226/api",
  directApiUrl: "https://localhost:7227/api",
  apiUrl: "https://analytics3qa-api.azurewebsites.net/api",
  envName: "DEV",
  enableFormsAuth: "true",
  instrumentationKey: "51f9321f-2795-43a7-ac2e-868084f506ef",
  defaultSiteId: "9126",
  agGridLicense:
    "Using_this_{AG_Grid}_Enterprise_key_{AG-064815}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Solera_Holdings}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{DealerSocket_Analytics}_only_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{DealerSocket_Analytics}_need_to_be_licensed___{DealerSocket_Analytics}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{30_September_2025}____[v3]_[01]_MTc1OTE4NjgwMDAwMA==4218a3665c06325be19a43c5fef25581",
  trackException: true,
  trackRequest: true,
  trackResponse: true
};

class GlobalConfig {
  config: DynamicConfig = defaultConfig;
  notDefinedYet = true;

  public get(): DynamicConfig {
    if (this.notDefinedYet) {
      throw new Error(
        "Global config has not been defined yet. Be sure to call the getter only after the config has been downloaded and set. Probable cause is accessing globalConfig in static context."
      );
    } else {
      return this.config;
    }
  }

  public set(value: DynamicConfig): void {
    if (this.notDefinedYet) {
      this.config = value;
      this.notDefinedYet = false;
    } else {
      throw new Error(
        "Global config has already been defined and now has been called second time. This is probably not intended."
      );
    }
  }
}

export const globalConfig = new GlobalConfig();

export const globalConfigUrl = "app.settings.json";

export interface PermissionAIEntry {
  name: string;
  code: string;
  visibility: boolean;
  permissionLevel: "socket" | "user" | "none";
}

class PermissionAIConfig {
  private permissions: PermissionAIEntry[] = [];

  public set(entries: PermissionAIEntry[]): void {
    this.permissions = entries;
  }

  public getEntries(): PermissionAIEntry[] {
    return this.permissions;
  }
}

export const permissionAIConfig = new PermissionAIConfig();

export const permissionAIConfigUrl = "Permission_AI.json";
